import React, {ReactNode, useEffect, useState} from 'react';
import { AppContainer, 
  ContainerCustom, 
  FooterContainer,
  WaiterContainer,
  Logo,
  FooterLink,
  FooterText,
  GridAlignContedCentered} from './template'
import { Grid, Typography, Box, Alert } from '@mui/material';
import { isMobile } from 'react-device-detect';
import settings from '../utilities/settings';
import { BLACK, WHITE } from '../theme/colors';
import Header from '../components/Header';
import DrawerComponent from '../components/DrawerComponent';
import useHeaderHeight from '../hooks/UseHeaderHeight';
import UseFooterHeight from '../hooks/UseFooterHeight';
import CustomWaiter from '../components/Waiter';
import { useWaiter } from '../hooks/waiter/WaiterProvider';
import FooterNavigation from '../components/Footer/FooterNavigation';
import { useNavigate } from 'react-router-dom';
import { useTranslationContext } from '../hooks/translations/translationsProvider';
import { useUserContext } from '../hooks/auth/UserProvider';
import { getAssobayLegalUrl } from '../helpers/assobayLegalLinks';

interface LayoutProps{
  children: ReactNode
}
const Layout: React.FC<LayoutProps> = ({children}) =>{
  const headerHeight = useHeaderHeight();
  const footerHeight = UseFooterHeight();
  const [headerH, setHeaderH] = useState(0)
  const [footerH, setFooterH] = useState(0)
  const {waiterView} = useWaiter();
  const navigate = useNavigate();
  const {t} = useTranslationContext();
  const {auth, isForbidden, isForbiddenMessage} = useUserContext();

  useEffect(()=>{
    setHeaderH(headerHeight + 40)
    console.log('headerHeight', headerHeight)
  },[headerHeight])

  // Force header height update when Alert visibility changes
  useEffect(()=>{
    // Wait for layout to settle after Alert appears/disappears
    const timeoutId = setTimeout(() => {
      const header = document.getElementById('header');
      if (header) {
        const newHeight = header.offsetHeight;
        setHeaderH(newHeight + 40);
        console.log('headerHeight forced update after isForbidden change:', newHeight)
      }
    }, 100); // Small delay to allow layout to settle

    return () => clearTimeout(timeoutId);
  },[isForbidden])

  useEffect(()=>{
    setFooterH(footerHeight + 30)
  },[footerHeight, isForbidden])

  return (
    <>
      <AppContainer>
        <Header/>

        <ContainerCustom headerH={headerH} footerH={footerH}
          maxWidth='lg'
          id='container-custom'
        >
            {isForbidden && (
              <Box display='flex' justifyContent='center' alignItems='center'>
                <Alert severity="error" sx={{ marginBottom: 4, marginTop: 4}}>
                  {t(isForbiddenMessage || "Forbidden User")}
                </Alert>
              </Box>
            )}
            
            {children}
          {
            waiterView && <WaiterContainer>
              <CustomWaiter width={100} size={80}/>
            </WaiterContainer>
          }
        </ContainerCustom>
        
        { !isMobile ? (
            <FooterContainer id="footer" auth={auth}>
            {/** Per dispositivi mobili non autenticati*/}
            <Grid container sm={12} spacing={2} justifyContent="center" sx={{ maxWidth: "lg", padding:'5px 0' }}>
              <GridAlignContedCentered item xs={'auto'} key="name-address">
                <Box>
                  <FooterText sx={{marginBottom:0.2}}>
                    <Box
                      component="span"
                      sx={{
                        fontFamily: 'inherit',
                        fontSize: 'inherit',
                        lineHeight: 'inherit',
                        color: 'inherit',
                        fontWeight: 700,
                        letterSpacing: 2,
                      }}
                    >
                      {settings.Details.Owner.Name}
                    </Box>, {settings.Details.Owner.Address}
                  </FooterText>
                </Box>
              </GridAlignContedCentered>
              <GridAlignContedCentered 
                item 
                sx={{ 
                  display: { xs: 'flex', sm: 'flex' }, 
                  alignItems:'center', 
                  color: WHITE, 
                  px: 0.5, 
                  userSelect: 'none' 
                }}
              >
                -
              </GridAlignContedCentered>
              <GridAlignContedCentered item xs={'auto'} sx={{ }} key="nation">
                <Box>
                  <FooterText>{settings.Details.Owner.Nation}</FooterText>
                </Box>
              </GridAlignContedCentered>
              <GridAlignContedCentered 
                item 
                sx={{ 
                  display: { xs: 'flex', sm: 'flex' }, 
                  alignItems:'center', 
                  color: WHITE, 
                  px: 0.5, 
                  userSelect: 'none' 
                }}
              >
                -
              </GridAlignContedCentered>
              <GridAlignContedCentered item xs={'auto'} sx={{ }} key="vat">
                <Box>
                  <FooterText>CN {settings.Details.Owner.VAT}</FooterText>
                </Box>
              </GridAlignContedCentered>
              <GridAlignContedCentered 
                item 
                sx={{ 
                  display: { xs: 'flex', sm: 'flex' }, 
                  alignItems:'center', 
                  color: WHITE, 
                  px: 0.5, 
                  userSelect: 'none' 
                }}
              >
                -
              </GridAlignContedCentered>
              <GridAlignContedCentered item xs={'auto'} sx={{ }} key="email">
                <Box>
                  <FooterLink href={`mailto:${settings.Details.Owner.Email}`}>{settings.Details.Owner.Email}</FooterLink>
                </Box>
              </GridAlignContedCentered >
              <GridAlignContedCentered 
                item 
                sx={{ 
                  display: { xs: 'flex', sm: 'flex' }, 
                  alignItems:'center', 
                  color: WHITE, 
                  px: 0.5, 
                  userSelect: 'none' 
                }}
              >
                -
              </GridAlignContedCentered>
              
              <GridAlignContedCentered item xs={'auto'} key="privacy">
                <Box>
                <FooterLink 
                    href={getAssobayLegalUrl('privacy')} 
                    target="_blank"
                    rel="noopener noreferrer"
                  >Privacy Policy</FooterLink>
                </Box>
              </GridAlignContedCentered >
              <GridAlignContedCentered 
                item 
                sx={{ 
                  display: { xs: 'flex', sm: 'flex' }, 
                  alignItems:'center', 
                  color: WHITE, 
                  px: 0.5, 
                  userSelect: 'none' 
                }}
              >
                -
              </GridAlignContedCentered>
              <GridAlignContedCentered item xs={'auto'} key="cookie">
                <Box>
                <FooterLink 
                    href={getAssobayLegalUrl('cookie')} 
                    target="_blank"
                    rel="noopener noreferrer"
                  >Cookie</FooterLink>
                </Box>
              </GridAlignContedCentered >

            </Grid>
          </FooterContainer>

          ) : (isMobile && !auth.isAuthenticated) ? (
            <FooterContainer id="footer" auth={auth}>
            {/** Per dispositivi mobili non autenticati*/}
            <Grid container sm={12} spacing={2} justifyContent="center" sx={{ maxWidth: "lg", padding:'5px 0' }}>
              <GridAlignContedCentered item xs={'auto'} key="name-address">
                <Box>
                  <FooterText sx={{marginBottom:0.2}}>
                    <Box
                      component="span"
                      sx={{
                        fontFamily: 'inherit',
                        fontSize: 'inherit',
                        lineHeight: 'inherit',
                        color: 'inherit',
                        fontWeight: 700,
                        letterSpacing: 2,
                      }}
                    >
                      {settings.Details.Owner.Name}
                    </Box>, {settings.Details.Owner.Address}
                  </FooterText>
                </Box>
              </GridAlignContedCentered>
              <GridAlignContedCentered 
                item 
                sx={{ 
                  display: { xs: 'flex', sm: 'flex' }, 
                  alignItems:'center', 
                  color: WHITE, 
                  px: 0.5, 
                  userSelect: 'none' 
                }}
              >
                -
              </GridAlignContedCentered>
              <GridAlignContedCentered item xs={'auto'} sx={{ }} key="nation">
                <Box>
                  <FooterText>{settings.Details.Owner.Nation}</FooterText>
                </Box>
              </GridAlignContedCentered>
              <GridAlignContedCentered 
                item 
                sx={{ 
                  display: { xs: 'flex', sm: 'flex' }, 
                  alignItems:'center', 
                  color: WHITE, 
                  px: 0.5, 
                  userSelect: 'none' 
                }}
              >
                -
              </GridAlignContedCentered>
              <GridAlignContedCentered item xs={'auto'} sx={{ }} key="vat">
                <Box>
                  <FooterText>CN {settings.Details.Owner.VAT}</FooterText>
                </Box>
              </GridAlignContedCentered>
              <GridAlignContedCentered 
                item 
                sx={{ 
                  display: { xs: 'flex', sm: 'flex' }, 
                  alignItems:'center', 
                  color: WHITE, 
                  px: 0.5, 
                  userSelect: 'none' 
                }}
              >
                -
              </GridAlignContedCentered>
              <GridAlignContedCentered item xs={'auto'} sx={{ }} key="email">
                <Box>
                  <FooterLink href={`mailto:${settings.Details.Owner.Email}`}>{settings.Details.Owner.Email}</FooterLink>
                </Box>
              </GridAlignContedCentered >
              <GridAlignContedCentered 
                item 
                sx={{ 
                  display: { xs: 'flex', sm: 'flex' }, 
                  alignItems:'center', 
                  color: WHITE, 
                  px: 0.5, 
                  userSelect: 'none' 
                }}
              >
                -
              </GridAlignContedCentered>
              
              <GridAlignContedCentered item xs={'auto'} key="privacy">
                <Box>
                <FooterLink 
                    href={getAssobayLegalUrl('privacy')} 
                    target="_blank"
                    rel="noopener noreferrer"
                  >Privacy Policy</FooterLink>
                </Box>
              </GridAlignContedCentered >
              <GridAlignContedCentered 
                item 
                sx={{ 
                  display: { xs: 'flex', sm: 'flex' }, 
                  alignItems:'center', 
                  color: WHITE, 
                  px: 0.5, 
                  userSelect: 'none' 
                }}
              >
                -
              </GridAlignContedCentered>
              <GridAlignContedCentered item xs={'auto'} key="cookie">
                <Box>
                <FooterLink 
                    href={getAssobayLegalUrl('cookie')} 
                    target="_blank"
                    rel="noopener noreferrer"
                  >Cookie</FooterLink>
                </Box>
              </GridAlignContedCentered >

            </Grid>
          </FooterContainer>
          ): (
            <FooterContainer id="footer" auth={auth}>
              {/** Per dispositivi mobili */}
              <FooterNavigation /> 
            </FooterContainer>
          )
        }
      </AppContainer>
      <DrawerComponent />
    </>
  );
}

export default Layout;
